import { useEffect, useState } from 'react';
import api from './api';

let cache = null;

export const fetchOverrides = (force = false) => {
  if (!cache || force) cache = api.get('/questionnaire-overrides').then((r) => r.data || {}).catch(() => ({}));
  return cache;
};

export const useQuestionnaireOverrides = () => {
  const [ov, setOv] = useState(null);
  useEffect(() => { let on = true; fetchOverrides().then((d) => on && setOv(d)); return () => { on = false; }; }, []);
  return ov;
};

export const hasRequired = (s) => s.fields.some((f) => f.required);

// Apply admin changes: hidden sections + reworded questions (original label kept as `key`)
export const applyOverrides = (def, ov) => {
  if (!ov) return def;
  const hidden = ov.hiddenSections || {};
  const labels = ov.labels || {};
  const options = ov.options || {};
  return {
    ...def,
    sections: def.sections.map((s) => ({
      ...s,
      hidden: hasRequired(s) ? s.hidden : (hidden[s.title] ?? s.hidden),
      fields: s.fields.map((f) => ({
        ...f, key: f.label, label: labels[f.label] || f.label,
        ...(f.options && f.type !== 'universe' && options[f.label]?.length ? { options: options[f.label] } : {}),
      })),
    })),
  };
};
